<section class="main-section">

  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/myAccountList/">My Accounts</a></li>
      <li class="breadcrumb-item active" aria-current="page">Edit API</li>
    </ol>
  </nav>

  <div class="row">
    <div class="col">
      <div class="inner-box">
        <div class="row mt-3">
          <div class="col-md-5">
            <div class="form-group">
              <label class="control-label" for="apiName">API Name</label>
              <input type="text" id="apiName" [(ngModel)]="viewData.apiName" [ngClass]="{'is-invalid':apiNameError}" class="form-control" [ngModelOptions]="{standalone: true}" required>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-5">
            <div class="form-group">
              <label class="control-label" for="api">API Key</label>
              <input type="text" id="api" [(ngModel)]="viewData.apiKey" class="form-control" disabled [ngClass]="{'is-invalid':getApiKeyError}" [ngModelOptions]="{standalone: true}"  required>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-5">
            <div class="form-group">
              <label class="control-label" for="secretKey">Secret Key</label>
              <input type="text" id="secretKey" [(ngModel)]="viewData.secretKey" class="form-control" disabled [ngClass]="{'is-invalid':getSecretKeyError}" [ngModelOptions]="{standalone: true}" #userInput required>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-5">
            <div class="form-group">
              <label class="control-label" for="url">URL</label>
              <input type="text" id="url" [(ngModel)]="viewData.redirectUrl" [ngClass]="{'is-invalid':urlError}" class="form-control" [ngModelOptions]="{standalone: true}" required>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 text-right">
            <button type="submit"  class="btn btn-orange" (click)="save()">Save</button>
          </div>
          <!--
                    <a (click)="copyInputMessage(userInput)">
                      <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-clipboard-plus" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
                        <path fill-rule="evenodd" d="M9.5 1h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3zM8 7a.5.5 0 0 1 .5.5V9H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V10H6a.5.5 0 0 1 0-1h1.5V7.5A.5.5 0 0 1 8 7z"/>
                      </svg>
                    </a>
          -->
        </div>

      </div>
      <div class="row mb-5">
        <div class="col-6">
          <div class="inner-box mt-3"  *ngFor="let notification of openList | slice:0: sliceUPto(openList?.length)">
            <table class="table" >
              <thead>
              <tr>
                <th>{{notification.groupName}}</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let n of notification?.apiSettingsResponses">
                <td width="25%">
                  <div class="toggle-2">
                    <input type="checkbox" name="onoffswitch" id="{{n.typeName}}" class="custom-control-input" [ngModel]="n.enabled" [ngModelOptions]="{standalone: true}" (change)="openUpdateStatus(n)" class="checkbox"/>
                    <label for="{{n.typeName}}" class="toggle">
                      <span>ON</span><span>OFF</span>
                    </label>
                  </div>
                </td>
                <td>{{n?.typeName}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-6">
          <div class="inner-box mt-3"  *ngFor="let notification of openList | slice:sliceUPto(openList?.length):openList?.length">
            <table class="table" >
              <thead>
              <tr>
                <th>{{notification.groupName}}</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let n of notification?.apiSettingsResponses">
                <td width="25%">
                  <div class="toggle-2">
                    <input type="checkbox" name="onoffswitch" id="c-{{n.typeName}}" class="custom-control-input" [ngModel]="n.enabled" [ngModelOptions]="{standalone: true}" (change)="openUpdateStatus(n)" class="checkbox"/>
                    <label for="c-{{n.typeName}}" class="toggle">
                      <span>ON</span><span>OFF</span>
                    </label>
                  </div>
                </td>
                <td>{{n?.typeName}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

</section>
